import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './GuestForm.scss';
import { noAutofillProps } from './noAutofillProps';

/**
 * Guest form modal - collects First Name and Last Name before continuing as guest.
 * Stores guestUser flag and guest data in localStorage for cart/wishlist.
 */
export function GuestForm({ onClose, onSuccess }) {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const f = firstName.trim();
    const l = lastName.trim();
    if (!f) {
      setError('First name is required.');
      return;
    }
    if (!l) {
      setError('Last name is required.');
      return;
    }
    setError('');
    localStorage.setItem('guestUser', 'true');
    localStorage.setItem('guestFirstName', f);
    localStorage.setItem('guestLastName', l);
    localStorage.setItem('guestCart', JSON.stringify([]));
    localStorage.setItem('guestWishlist', JSON.stringify([]));
    onSuccess?.();
    onClose?.();
    navigate('/');
  };

  return (
    <div className="guest-form-overlay" onClick={onClose}>
      <div className="guest-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="guest-form-header">
          <h3>Continue as Guest</h3>
          <p className="guest-form-subtitle">Enter your name to continue</p>
        </div>
        <form onSubmit={handleSubmit} className="guest-form-body" autoComplete="off">
          <div className="form-group">
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              {...noAutofillProps({ autoFocus: true })}
            />
          </div>
          <div className="form-group">
            <input
              type="text"
              placeholder="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              {...noAutofillProps()}
            />
          </div>
          {error && <div className="guest-form-error">{error}</div>}
          <div className="guest-form-actions">
            <button type="button" className="guest-form-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="guest-form-continue">
              Continue
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
